import { Button, Card, Spin, Typography } from "antd";
import { Download, Eye, FileText } from "lucide-react";
import React from "react";
import { TFile } from "~/types";

const { Text } = Typography;

interface DocumentListProps {
  documents: TFile[];
  isLoading: boolean;
  onView: (doc: TFile) => void;
  onDownload?: (doc: TFile) => void;
}

export const DocumentList: React.FC<DocumentListProps> = ({
  documents,
  isLoading,
  onView,
  onDownload,
}) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();

    if (date.toDateString() === now.toDateString()) {
      return `${date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })} Today`;
    }

    return date.toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <Card classNames={{ body: "p-0" }}>
      <div className="p-4 border-b">
        <Text strong>Recent Documents</Text>
      </div>
      {isLoading ? (
        <div className="p-6 flex justify-center">
          <Spin />
        </div>
      ) : (
        <div className="divide-y">
          {documents.length > 0 ? (
            documents.map((doc) => (
              <div
                key={doc.id}
                className="p-4 hover:bg-gray-50 flex justify-between items-center"
              >
                <div className="flex items-center">
                  <FileText size={16} className="mr-2 text-blue-600" />
                  <div>
                    <Text strong>{doc.title}</Text>
                    <Text type="secondary" className="text-sm block">
                      {formatDate(doc.createdAt)}
                    </Text>
                  </div>
                </div>
                <div className="flex space-x-2">
                  <Button
                    type="text"
                    icon={<Eye size={16} />}
                    onClick={() => onView(doc)}
                  />
                  {onDownload && (
                    <Button
                      type="text"
                      icon={<Download size={16} />}
                      onClick={() => onDownload(doc)}
                    />
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="p-6 text-center text-gray-400">
              <FileText size={24} className="mx-auto mb-2" />
              <Text>No documents found</Text>
            </div>
          )}
        </div>
      )}
    </Card>
  );
};